import { useSubscription } from '@apollo/client';
import { ENTITY_TYPE_CHANGED } from 'features/offer/edit/insurances/subscriptions';
import { useResetCache } from 'utils/apollo/common';
import { cachedEntities } from '../constants/cachedEntities';
import { configurationKeys } from '../constants/configurationKey';
import { CACHE_RESET } from 'components/settings/subscriptions';

const GlobalSubscriptionArea = () => {
  const { resetApolloCache } = useResetCache();

  useSubscription(ENTITY_TYPE_CHANGED, {
    onSubscriptionData: ({ subscriptionData: { data } }) => {
      if (!cachedEntities) return;
      if (cachedEntities.includes(data?.entityTypeChanged?.entityName)) resetApolloCache(configurationKeys);
    }
  });

  useSubscription(CACHE_RESET, {
    onSubscriptionData: () => {
      resetApolloCache(configurationKeys);
    }
  });

  return '';
};

export default GlobalSubscriptionArea;
